import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=e3f61dde&scoped=true"
import script from "./fields.vue?vue&type=script&lang=js"
export * from "./fields.vue?vue&type=script&lang=js"
import style0 from "./fields.vue?vue&type=style&index=0&id=e3f61dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f61dde",
  null
  
)

export default component.exports